import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const RefreshIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 22, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={+size * (20 / 22)}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.0645 5.19096C20.7399 4.9663 20.2977 5.0512 20.0764 5.38058L18.6262 7.5395C18.2494 5.75733 17.3767 4.11973 16.0781 2.80142C14.2988 0.994897 11.933 0 9.41652 0C6.90012 0 4.53429 0.994897 2.75493 2.80142C-0.91831 6.53074 -0.91831 12.5988 2.75493 16.328C4.59155 18.1927 7.00403 19.125 9.41652 19.125C11.829 19.125 14.2415 18.1927 16.0781 16.328C16.3558 16.0461 16.3558 15.589 16.0781 15.307C15.8004 15.0251 15.3502 15.0251 15.0726 15.307C11.9538 18.4734 6.87936 18.4734 3.76065 15.307C0.641945 12.1407 0.641945 6.98863 3.76065 3.8223C5.27142 2.28857 7.28002 1.44383 9.41661 1.44383C11.5532 1.44383 13.5619 2.28857 15.0726 3.8224C16.2386 5.00615 16.9986 6.49359 17.2854 8.10837L14.7613 6.36056C14.4369 6.1359 13.9945 6.2208 13.7732 6.55019C13.5519 6.87957 13.6356 7.3287 13.96 7.55336L17.7252 10.1606C17.7254 10.1607 17.7256 10.1609 17.7258 10.1611C17.7853 10.2023 17.8488 10.2326 17.9142 10.2533C17.9161 10.254 17.918 10.2551 17.92 10.2556C17.9311 10.2591 17.9424 10.2604 17.9536 10.2633C18.0105 10.2778 18.0681 10.2866 18.1258 10.2866C18.3529 10.2866 18.5762 10.1763 18.7139 9.97149L21.2513 6.19423C21.4726 5.86475 21.389 5.41562 21.0645 5.19096Z"
        fill="currentColor"
      />
    </svg>
  )
})

RefreshIcon.displayName = 'RefreshIcon'
